import {createTheme} from "@mui/material";

declare module "@mui/material/styles" {
	// allow configuration using `createTheme`
	// eslint-disable-next-line @typescript-eslint/naming-convention
	interface ThemeOptions {
		[key: string]: unknown;
	}
}

export const themeObject = {
	fonts: {
		primary: '"Proxima Nova", sans-serif',
		secondary: '"Proxima Nova", sans-serif',
	},
	colors: {
		text: {
			dark: "#1C1C1E",
			white: "#FFFFFF",
		},
		brand: {
			primary: "#1271F0",
			primaryHover: "#1654A0",
			secondary: "#D3421A",
			secondaryHover: "#B5300C",
			black: "#161616",
			gold: "#EBCA5E",
		},
		input: {
			label: "#A3A3A3",
			placeholder: "#FF00B8",
			filled: "#000000",
			error: "#C20000",
			grey: "#F3F3F3",
			borderGrey: "#D9D9D9",
		},
	},

	buttons: {
		primary: {
			default: {
				background: "#1271F0",
				color: "#FFFFFF",
				borderColor: "#1271F0",
			},
			hover: {
				background: "#1654A0",
				color: "#FFFFFF",
				borderColor: "#1654A0",
			},
			disabled: {
				background: "#1271F0",
				color: "#FFFFFF",
				borderColor: "#1271F0",
				opacity: 0.3,
			},
		},
		secondary: {
			default: {
				background: "#D3421A",
				color: "#FFFFFF",
				borderColor: "#D3421A",
			},
			hover: {
				background: "#B5300C",
				color: "#FFFFFF",
				borderColor: "#B5300C",
			},
			disabled: {
				background: "#D3421A",
				color: "#FFFFFF",
				borderColor: "#D3421A",
				opacity: 0.3,
			},
		},
		outline: {
			default: {
				background: "transparent",
				color: "#FFFFFF",
				borderColor: "#FFFFFF",
			},
			hover: {
				background: "#FFFFFF",
				color: "#161616",
				borderColor: "#FFFFFF",
			},
			disabled: {
				background: "transparent",
				color: "#FFFFFF",
				borderColor: "#FFFFFF",
				opacity: 0.3,
			},
		},
	},

	playCard: {
		correctColor: "#139F5A",
		incorrectColor: "#B5300C",
	},

	guess: {
		correctColor: "#18C971",
		incorrectColor: "#ff5c5c",
	},

	header: {
		background: "#161616",
		color: "#FFFFFF",
		stats: {
			background: "#1A232D",
			color: "#FFFFFF",
		},
		menu: {
			background: "#1C1C1E",
		},
	},

	summaryCard: {
		stats: {
			background: "#232F3B",
			color: "#FFFFFF",
		},
		final: {
			background: "#1654A0",
			avgBackground: "#232F3B",
			color: "#FFFFFF",
			avgColor: "#C7C7CC",
		},
	},
};

type ITheme = typeof themeObject;
export const theme = createTheme(themeObject);

declare module "@mui/material/styles" {
	/**
	 *Disabled as it's allowing to avoid `any` type per MUI documentation
	 * https://mui.com/material-ui/customization/theming/#custom-variables
	 */

	// eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-empty-interface
	interface Theme extends ITheme {}
}

declare module "@emotion/react" {
	/**
	 *Disabled as it's allowing to avoid `any` type per Emotion documentation
	 * https://emotion.sh/docs/typescript#define-a-theme
	 */

	// eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-empty-interface
	interface Theme extends ITheme {}
}

export const breakpoints = {
	mobile: "640px",
};
